import React from 'react';
import { Styled } from './MapPopup.styles';
import { IconButton } from 'office-ui-fabric-react';
import { Props } from './MapPopup.types';
import { Page } from '../../components/Page';
import { PageHeader } from '../../components/PageHeader';
import { BackButton } from '../../components/NavigationButton';

export const MapPopup: React.FC<Props> = ({ children, onClose, label }) => {
  return (
    <Page
      primaryButtonNode={<BackButton onClick={onClose} />}
      title={label}
      pinToTop
    >
      <Styled.MapPopup>
        <Styled.Body>{children}</Styled.Body>
      </Styled.MapPopup>
    </Page>
  );
};
